import { companyBasePath } from "@oysterhr/router"
import { stringify } from "query-string"
import { GlobalSalaryConverterQueryParams, SalaryInsightsQueryParams } from "../../utils"

export const companyResourcesPath = ({ companyId }: { companyId?: string } = {}) =>
  companyBasePath({ companyId, path: "resources" })

export const companyToolkitPath = ({ companyId }: { companyId?: string } = {}) =>
  companyBasePath({ companyId, path: "toolkit" })

export const companySalaryInsightsToolPath = ({
  companyId,
  query,
}: { companyId?: string; query?: SalaryInsightsQueryParams } = {}) =>
  companyBasePath({
    companyId,
    path: "salary-insights-tool",
    query: stringify(query || {}),
  })

export const companySalaryInsightsResultsPath = ({
  companyId,
  query,
}: {
  companyId?: string
  query?: SalaryInsightsQueryParams
} = {}) =>
  companyBasePath({
    companyId,
    path: "salary-insights-tool/results",
    query: stringify(query || {}),
  })

export const companySalaryInsightsCheckoutPath = ({
  companyId,
  query,
}: {
  companyId?: string
  query?: SalaryInsightsQueryParams
} = {}) =>
  companyBasePath({
    companyId,
    path: "salary-insights-tool/checkout",
    query: stringify(query || {}),
  })

export const companyPaymentMethodCheckoutPath = ({ companyId }: { companyId?: string } = {}) =>
  companyBasePath({ companyId, path: "payment-methods" })

export const companyGlobalSalaryConverterPath = ({ companyId }: { companyId?: string } = {}) =>
  companyBasePath({
    companyId,
    path: "global-salary-converter",
  })

export const companyGlobalSalaryConverterResultsPath = ({
  companyId,
  query,
}: {
  companyId?: string
  query?: GlobalSalaryConverterQueryParams
} = {}) =>
  companyBasePath({
    companyId,
    path: "global-salary-converter/results",
    query: stringify(query || {}),
  })

export const companyEmploymentComparatorPath = ({
  companyId,
}: {
  companyId?: string
} = {}) =>
  companyBasePath({
    companyId,
    path: "employment-comparator",
  })

export const companyEmploymentCostComparisonPath = ({
  companyId,
}: {
  companyId?: string
} = {}) =>
  companyBasePath({
    companyId,
    path: "employment-cost-comparison",
  })

export const companyWorkforceCompensationPath = ({ companyId }: { companyId?: string } = {}) =>
  companyBasePath({ companyId, path: "workforce-compensation" })

export const companyWorkforceCompensationNewReportPath = ({
  companyId,
}: {
  companyId?: string
} = {}) =>
  companyBasePath({
    companyId,
    path: "workforce-compensation/reports/new",
  })

export const companyWorkforceCompensationReportPath = ({
  companyId,
  reportStrongId,
  queryParams,
}: {
  companyId?: string
  reportStrongId?: string
  /**
   * This needs to be prefixed with ?
   */
  queryParams?: string
}) => {
  if (queryParams) {
    return companyBasePath({
      companyId,
      path: `workforce-compensation/reports/${reportStrongId}/edit${queryParams}`,
    })
  } else {
    return companyBasePath({
      companyId,
      path: `workforce-compensation/reports/${reportStrongId}/edit`,
    })
  }
}

export const companyWorkforceCompensationResultPath = ({
  companyId,
  reportId,
}: {
  companyId?: string
  reportId?: string
} = {}) =>
  companyBasePath({
    companyId,
    path: `workforce-compensation/reports/${reportId}/result`,
  })
